import { Link } from 'react-router-dom';
import './dashboard.scss';
import { useParams, useHistory } from 'react-router-dom';

function Dashboard() {
    const params: any = useParams();
    const history = useHistory();

    const goBack = () => {
        history.goBack();
    }

    return (
        <div className="dashboard">
            <div className="top">
                <i className="fal fa-arrow-circle-left" onClick={goBack}></i>
                Dashboard
            </div>
            <div className="body">
                <Link to={`/client/${params.clientId}/projects`}>
                    <img src={`${process.env.PUBLIC_URL}/img/projects.svg`} alt="" />
                    <p>Projects</p>
                </Link>
                <Link to={`/client/${params.clientId}/contact-management`}>
                    <img src={`${process.env.PUBLIC_URL}/img/contact-management.svg`} alt="" />
                    <p>Contact Management</p>
                </Link>
            </div>
        </div>
    )
}

export default Dashboard;